module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    staticClass: "viewport",
    class: {
      clickable: _vm.clickable
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "mousedown": _vm.start,
      "mousemove": _vm.move,
      "mouseup": _vm.stop,
      "mouseout": _vm.stop,
      "touchstart": _vm.start,
      "touchmove": _vm.move,
      "touchend": _vm.stop
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fab5972!./~/vue-loader/lib/selector.js?type=template&index=0!./src/viewport.vue
// module id = 29
// module chunks = 0